import { EnrollmentStatusEnum } from '@/models/Enrollment';

export const enrollmentValidation = (status?: EnrollmentStatusEnum) => {
  if (!status) return false;

  return [EnrollmentStatusEnum.ACTIVE, EnrollmentStatusEnum.CONCLUDED].includes(
    status,
  );
};
